/**
 * Cross-sell card – color swatch interaction.
 * Swatch'a tıklayınca kartın görselini o varyantın görseliyle değiştirir ve
 * kart linkini (.product-card__link) varyant URL'ine günceller.
 * Event delegation; tek listener tüm cross-sell kartlarını yönetir.
 */
(function () {
  'use strict';

  if (window.__pcsCardSwatchBound) return;
  window.__pcsCardSwatchBound = true;

  function parseWidths(widthsJson) {
    try { return JSON.parse(widthsJson || '[]'); }
    catch (_) { return [200, 300, 400, 500, 600, 700, 800]; }
  }

  function buildSrcset(urlTemplate, widths) {
    var parts = [];
    for (var i = 0; i < widths.length; i++) {
      parts.push(urlTemplate.replace('__WIDTH__', widths[i]) + ' ' + widths[i] + 'w');
    }
    return parts.join(', ');
  }

  function bestWidthFor(el, widths) {
    var containerWidth = el.parentElement ? el.parentElement.offsetWidth : 400;
    var dpr = window.devicePixelRatio || 1;
    var target = Math.ceil(containerWidth * dpr);
    var best = widths[widths.length - 1] || 800;
    for (var i = 0; i < widths.length; i++) {
      if (widths[i] >= target) { best = widths[i]; break; }
    }
    return best;
  }

  function preloadAndSet(img, urlTemplate, widthsJson) {
    if (!urlTemplate) return;
    var widths = parseWidths(widthsJson);
    if (!widths.length) widths = [200, 300, 400, 500, 600, 700, 800];
    var best = bestWidthFor(img, widths);
    var srcset = buildSrcset(urlTemplate, widths);
    var newSrc = urlTemplate.replace('__WIDTH__', best);

    var preload = new Image();
    var apply = function () {
      img.setAttribute('srcset', srcset);
      img.src = newSrc;
    };
    preload.onload = apply;
    preload.onerror = apply;
    preload.src = newSrc;
  }

  function handleSwatchClick(e) {
    var swatch = e.target.closest('[data-pcs-swatch]');
    if (!swatch) return;

    e.preventDefault();
    e.stopPropagation();

    var card = swatch.closest('[data-pcs-card]');
    if (!card) return;

    var swatchGroup = card.querySelectorAll('[data-pcs-swatch]');
    for (var i = 0; i < swatchGroup.length; i++) {
      swatchGroup[i].classList.remove('npc-card__swatch--active');
    }
    swatch.classList.add('npc-card__swatch--active');

    var newImageUrl = swatch.getAttribute('data-pcs-image-url');
    var newImageWidths = swatch.getAttribute('data-pcs-image-widths');
    var img = card.querySelector('.product-card__image img');

    if (newImageUrl && img) {
      preloadAndSet(img, newImageUrl, newImageWidths);
    }

    var variantUrl = swatch.getAttribute('data-pcs-variant-url');
    if (variantUrl) {
      var links = card.querySelectorAll('.product-card__link');
      for (var k = 0; k < links.length; k++) {
        links[k].href = variantUrl;
      }
    }
  }

  document.addEventListener('click', handleSwatchClick);
})();
